// demoData.js — deterministic demo data for dida
// Seed: 2026

function seededRng(seed) {
  let s = seed >>> 0;
  return {
    next()  { s = Math.imul(1664525, s) + 1013904223 | 0; return (s >>> 0) / 4294967296; },
    int(a,b){ return a + Math.floor(this.next()*(b-a+1)); },
    pick(a) { return a[this.int(0,a.length-1)]; },
    wgt(items,w){ let r=this.next(); for(let i=0;i<items.length;i++){r-=w[i];if(r<=0)return items[i];}return items[items.length-1]; }
  };
}

const AVATAR_PAIRS = [
  ["#E1F5EE","#085041"], ["#E6F1FB","#0C447C"], ["#FAEEDA","#633806"], ["#EEEDFE","#3C3489"],
  ["#FFF0E6","#7A3800"], ["#F0FFF4","#166534"], ["#FFF7ED","#9A3412"], ["#F0F9FF","#0369A1"],
  ["#FAFAF9","#44403C"], ["#FEF9EE","#92400E"]
];

function generateTeam() {
  const rng = seededRng(2026);

  const behandler = [
    { id:1, name:"Dr. Sandra Hoffmann", role:"Inhaberin/Allgemein+Prothetik", roleKey:"admin", initials:"DH", avatarBg:"#E1F5EE", avatarCol:"#085041", contract:"Vollzeit 40h", urlaub:30, urlaubGenommen:8, kranktage:0, ueberstunden:3, minusstunden:0, sick:false, sickNote:"", stunden:{Mo:8,Di:8,Mi:8,Do:8,Fr:6,Sa:0,So:0} },
    { id:2, name:"Dr. Marco Schulz",    role:"Zahnarzt/Chirurgie",                  roleKey:"arzt", initials:"DS", avatarBg:"#E6F1FB", avatarCol:"#0C447C", contract:"Vollzeit 40h", urlaub:28, urlaubGenommen:5,  kranktage:2, ueberstunden:0, minusstunden:2, sick:false, sickNote:"", stunden:{Mo:8,Di:8,Mi:0,Do:8,Fr:8,Sa:0,So:0} },
    { id:3, name:"Dr. Lisa Bergmann",   role:"Zahnärztin/KFO",                      roleKey:"arzt", initials:"LB", avatarBg:"#EEEDFE", avatarCol:"#3C3489", contract:"Teilzeit 30h", urlaub:25, urlaubGenommen:10, kranktage:0, ueberstunden:2, minusstunden:0, sick:false, sickNote:"", stunden:{Mo:6,Di:6,Mi:6,Do:6,Fr:6,Sa:0,So:0} },
    { id:4, name:"Dr. Tom Fischer",     role:"Arzt/Assistenz",                  roleKey:"arzt", initials:"TF", avatarBg:"#FFF0E6", avatarCol:"#7A3800", contract:"Vollzeit 35h", urlaub:20, urlaubGenommen:3,  kranktage:1, ueberstunden:0, minusstunden:3, sick:false, sickNote:"", stunden:{Mo:7,Di:7,Mi:7,Do:7,Fr:7,Sa:0,So:0} },
    { id:5, name:"Maja Roth",           role:"ZMP/Paro",                        roleKey:"dh",   initials:"MR", avatarBg:"#F0FFF4", avatarCol:"#166534", contract:"Teilzeit 35h", urlaub:22, urlaubGenommen:7,  kranktage:0, ueberstunden:1, minusstunden:0, sick:false, sickNote:"", stunden:{Mo:7,Di:7,Mi:7,Do:7,Fr:7,Sa:0,So:0} },
  ];

  const zfaNames = [
    { vorname:"Lisa",    nachname:"Beck",     fullRole:"Verwaltung",      contract:"Vollzeit 40h", stunden:{Mo:8,Di:8,Mi:8,Do:8,Fr:8,Sa:0,So:0} },
    { vorname:"Sara",    nachname:"Klein",    fullRole:"MFA · Empfang",   contract:"Vollzeit 40h", stunden:{Mo:8,Di:8,Mi:8,Do:0,Fr:8,Sa:0,So:0} },
    { vorname:"Tobias",  nachname:"Müller",   fullRole:"MFA · Empfang",   contract:"Vollzeit 40h", stunden:{Mo:8,Di:8,Mi:8,Do:8,Fr:8,Sa:0,So:0} },
  ];

  const zfas = zfaNames.map((z, i) => {
    const pair = AVATAR_PAIRS[i % AVATAR_PAIRS.length];
    const urlaub = rng.int(20, 28);
    const urlaubGenommen = rng.int(0, 15);
    const kranktage = rng.int(0, 3);
    const ueberstunden = rng.int(0, 6);
    const minusstunden = rng.int(0, 4);
    const numDays = rng.int(0, 12);
    const allDays = Array.from({length:30}, (_,j)=>j+1);
    const urlaubTageJuni = [];
    const pool = [...allDays];
    for (let d=0; d<numDays; d++) {
      const idx = rng.int(0, pool.length-1);
      urlaubTageJuni.push(pool[idx]);
      pool.splice(idx, 1);
    }
    return {
      id: 6 + i,
      name: `${z.vorname} ${z.nachname}`,
      role: z.fullRole,
      roleKey: "mfa",
      initials: z.vorname[0] + z.nachname[0],
      avatarBg: pair[0],
      avatarCol: pair[1],
      contract: z.contract,
      urlaub,
      urlaubGenommen,
      kranktage,
      ueberstunden,
      minusstunden,
      sick: false,
      sickNote: "",
      stunden: z.stunden,
      urlaubTageJuni,
    };
  });

  // Add urlaubTageJuni to behandler with RNG
  const behandlerWithUrlaub = behandler.map(b => {
    const numDays = rng.int(0, 10);
    const pool = Array.from({length:30}, (_,j)=>j+1);
    const urlaubTageJuni = [];
    for (let d=0; d<numDays; d++) {
      const idx = rng.int(0, pool.length-1);
      urlaubTageJuni.push(pool[idx]);
      pool.splice(idx, 1);
    }
    return { ...b, urlaubTageJuni };
  });

  return [...behandlerWithUrlaub, ...zfas];
}

function pad2(n){ return String(n).padStart(2,"0"); }

function generatePatients() {
  const rng = seededRng(2026 + 1);

  const VN_M = ["Alexander","Andreas","Benjamin","Bernd","Christian","Daniel","David","Dennis","Erik","Felix","Frank","Georg","Günter","Hans","Horst","Jan","Jonas","Jörg","Jürgen","Karl","Klaus","Lars","Lukas","Manfred","Markus","Martin","Matthias","Michael","Nico","Patrick","Paul","Peter","Philipp","Ralf","Robert","Sebastian","Stefan","Thomas","Tobias","Uwe","Walter","Werner","Wolfgang"];
  const VN_W = ["Andrea","Angela","Anna","Bettina","Birgit","Christina","Christine","Clara","Claudia","Daniela","Elisabeth","Emma","Eva","Hannah","Heike","Ines","Jana","Julia","Katharina","Katrin","Laura","Lena","Lisa","Maria","Martina","Monika","Nicole","Petra","Sandra","Sara","Silke","Sonja","Stefanie","Susanne","Teresa","Tina","Ursula","Vanessa","Vera","Yvonne"];
  const NN = ["Bauer","Beck","Berg","Braun","Engel","Fischer","Frank","Friedrich","Graf","Groß","Hartmann","Hecker","Henning","Hoffmann","Kaiser","Klein","Koch","Köhler","König","Krause","Krüger","Lang","Lange","Maier","Meyer","Möller","Müller","Peters","Richter","Roth","Schäfer","Schmidt","Schneider","Schulz","Schwarz","Simon","Stein","Wagner","Weber","Werner","Winkler","Wolf","Wolff","Zimmermann"];

  const TREATS = ["Dr. Hoffmann","Dr. Schulz","Dr. Bergmann","Dr. Fischer","Maja Roth"];
  const TREAT_W = [0.28, 0.20, 0.25, 0.15, 0.12];
  const KVS = ["AOK","TK","BKK","Privat","Barmer","DAK","Sonstige"];
  const KV_W = [0.30, 0.20, 0.15, 0.25, 0.05, 0.03, 0.02];
  const SRCS = ["Empfehlung","Google","Instagram","Werbung"];
  const SRC_W = [0.46, 0.28, 0.15, 0.11];
  const NEXTS = ["Aug. 2026","Sep. 2026","Okt. 2026","Nov. 2026","Jan. 2027","Feb. 2027"];

  const patients = [];
  for (let i = 0; i < 2000; i++) {
    const isMale = rng.next() < 0.5;
    const vorname = isMale ? rng.pick(VN_M) : rng.pick(VN_W);
    const nachname = rng.pick(NN);
    const treat = rng.wgt(TREATS, TREAT_W);
    const kv = rng.wgt(KVS, KV_W);
    const src = rng.wgt(SRCS, SRC_W);

    let age;
    if (treat === "Dr. Bergmann") {
      age = rng.next() < 0.6 ? rng.int(10,18) : rng.int(18,65);
    } else if (treat === "Dr. Schulz") {
      age = rng.next() < 0.7 ? rng.int(30,75) : rng.int(18,75);
    } else if (treat === "Dr. Hoffmann") {
      age = rng.next() < 0.5 ? rng.int(45,80) : rng.int(25,75);
    } else if (treat === "Dr. Fischer") {
      age = rng.int(18,70);
    } else {
      age = rng.int(20,75);
    }

    const curYear = 2026;
    const birthYear = curYear - age;
    const birthMonth = rng.int(1,12);
    const birthDay = rng.int(1,28);
    const dob = `${pad2(birthDay)}.${pad2(birthMonth)}.${birthYear}`;

    const lastYear = rng.int(24,25);
    const lastMonth = rng.int(1,12);
    const lastDay = rng.int(1,28);
    const last = `${pad2(lastDay)}.${pad2(lastMonth)}.${lastYear}`;

    const since = String(rng.int(2010, 2025));

    const statusR = rng.next();
    const status = statusR < 0.89 ? "Aktiv" : statusR < 0.97 ? "Erinnern" : "Inaktiv";

    const allergyR = rng.next();
    const allergy = allergyR < 0.85 ? "—" : allergyR < 0.90 ? "Penicillin" : allergyR < 0.94 ? "Latex" : allergyR < 0.97 ? "ASS" : allergyR < 0.99 ? "Jod" : "Nuss";

    const medsR = rng.next();
    let meds;
    if (medsR < 0.65) meds = "—";
    else if (medsR < 0.70) meds = "Metformin 500mg";
    else if (medsR < 0.76) meds = "Ramipril 5mg";
    else if (medsR < 0.81) meds = "L-Thyroxin 50µg";
    else if (medsR < 0.86) meds = "Bisoprolol 5mg";
    else if (medsR < 0.90) meds = "Ibuprofen 400mg";
    else if (medsR < 0.94) meds = "Amlodipin 5mg";
    else if (medsR < 0.98) meds = "Simvastatin 20mg";
    else meds = "Omeprazol 20mg";

    const prop = rng.next() < 0.68;
    const pzr = prop ? (rng.next() < 0.60 ? "2× jährlich" : "1× jährlich") : "—";
    const next = prop ? rng.pick(NEXTS) : "—";

    patients.push({ id: i+1, vorname, nachname, dob, kv, treat, last, since, status, allergy, meds, prop, pzr, next, src, history:[] });
  }
  return patients;
}

function generateReqs(patients) {
  const rng = seededRng(2026 + 2);
  const pool = patients.slice(0, 200);

  const MED_BY_TYP = {
    "Medikament": ["Amoxicillin 500mg","Clindamycin 300mg","Metronidazol 400mg","Ibuprofen 400mg","Ibuprofen 600mg","Paracetamol 500mg","Chlorhexamed 0,2%","Doxycyclin 100mg","Amoxicillin 1000mg","Penicillin V 1,0 Mega"],
    "Überweisung": ["Überweisung MKG-Chirurgie","Überweisung Kieferorthopädie","Überweisung Parodontologie","Überweisung Oralchirurgie","Überweisung Mund-Kiefer-Gesichtschirurgie"],
    "Heil- und Kostenplan": ["HKP Zahnersatz OK","HKP Zahnersatz UK","HKP Brücke 45-47","HKP Implantat 36","HKP Teilprothese UK"],
  };
  const TYPS = ["Medikament","Überweisung","Heil- und Kostenplan"];
  const TYP_W = [0.55, 0.25, 0.20];
  const SRCS = ["KI-Telefon","Online","Telefonisch"];
  const SRC_W = [0.55, 0.35, 0.10];

  const HOURS = ["07","08","09","10","11","12","13","14"];
  const DAYS = ["Mo.","Di.","Mi.","Do.","Fr."];

  const reqs = [];
  let id = 1;

  // 40 offen
  for (let i = 0; i < 40; i++) {
    const p = rng.pick(pool);
    const typ = rng.wgt(TYPS, TYP_W);
    const med = rng.pick(MED_BY_TYP[typ]);
    const src = rng.wgt(SRCS, SRC_W);
    const hh = rng.pick(HOURS);
    const mm = rng.int(0,59);
    const ago = rng.int(1,4);
    const ki = [];
    ki.push({ok: rng.next()<0.6, txt:"Patient bekannt"});
    ki.push({ok: rng.next()<0.5, txt:"Intervall plausibel"});
    if (rng.next()<0.5) ki.push({ok: rng.next()<0.4, txt:"Keine Kontraindikationen bekannt"});
    reqs.push({ id:id++, status:"offen", vorname:p.vorname, nachname:p.nachname, dob:p.dob, kv:p.kv, last:p.last, typ, med, src, time:`heute, ${hh}:${pad2(mm)}`, ago:`vor ${ago} Std.`, ki });
  }

  // 80 genehmigt
  for (let i = 0; i < 80; i++) {
    const p = rng.pick(pool);
    const typ = rng.wgt(TYPS, TYP_W);
    const med = rng.pick(MED_BY_TYP[typ]);
    const src = rng.wgt(SRCS, SRC_W);
    const day = rng.next()<0.5 ? "gestern" : rng.pick(DAYS);
    const hh = rng.pick(HOURS);
    const mm = rng.int(0,59);
    const timeStr = day==="gestern" ? `gestern, ${hh}:${pad2(mm)}` : `${day} ${hh}:${pad2(mm)}`;
    const ki = [
      {ok:true, txt:"Patient bekannt"},
      {ok:true, txt:"Dauermedikation bestätigt"},
    ];
    if (rng.next()<0.5) ki.push({ok:true, txt:"Intervall korrekt"});
    reqs.push({ id:id++, status:"genehmigt", vorname:p.vorname, nachname:p.nachname, dob:p.dob, kv:p.kv, last:p.last, typ, med, src, time:timeStr, ago:day==="gestern"?"gestern":day, ki });
  }

  // 20 abgelehnt
  for (let i = 0; i < 20; i++) {
    const p = rng.pick(pool);
    const typ = rng.wgt(TYPS, TYP_W);
    const med = rng.pick(MED_BY_TYP[typ]);
    const src = rng.wgt(SRCS, SRC_W);
    const day = rng.pick(DAYS);
    const hh = rng.pick(HOURS);
    const mm = rng.int(0,59);
    const ki = [
      {ok:false, txt:"Keine ausreichende Dokumentation"},
      {ok:false, txt:"Intervall zu kurz"},
    ];
    if (rng.next()<0.5) ki.push({ok:false, txt:"Termin erforderlich"});
    reqs.push({ id:id++, status:"abgelehnt", vorname:p.vorname, nachname:p.nachname, dob:p.dob, kv:p.kv, last:p.last, typ, med, src, time:`${day} ${hh}:${pad2(mm)}`, ago:day, ki, reason:"Persönlicher Behandlungstermin erforderlich." });
  }

  return reqs;
}

function generateInvoices(patients) {
  const rng = seededRng(2026 + 3);
  const pool = patients.slice(0, 100);

  const TYPS = ["Kassenabrechnung","Privatliquidation","IGeL","Selbstzahler"];
  const TYP_W = [0.55, 0.25, 0.15, 0.05];
  const STATI = ["bezahlt","offen","mahnung"];
  const STAT_W = [0.60, 0.28, 0.12];

  const PROCS = {
    "Kassenabrechnung": ["Kontrolle & Befund","Röntgen","Füllung Komposit","Extraktion einfach","Beratung","Parodontitisbehandlung","Prophylaxe-Sitzung"],
    "Privatliquidation": ["Krone Keramik","Implantation","Veneer","Brücke","Prothetik-Beratung","Wurzelbehandlung"],
    "IGeL": ["PZR","Bleaching","Fissurenversiegelung","OPG-Röntgen","Kiefergelenksanalyse","Anti-Aging-Beratung"],
    "Selbstzahler": ["Kontrolle & Befund","Beratung","Füllung Komposit","Prophylaxe-Sitzung"],
  };

  const RANGES = {
    "Kassenabrechnung":  [45, 180],
    "Privatliquidation": [150, 800],
    "IGeL":              [60, 300],
    "Selbstzahler":      [80, 250],
  };

  const today = new Date(2026, 5, 9); // June 9, 2026
  const invoices = [];

  for (let i = 0; i < 150; i++) {
    const p = rng.pick(pool);
    const typ = rng.wgt(TYPS, TYP_W);
    const status = rng.wgt(STATI, STAT_W);
    const [lo, hi] = RANGES[typ];
    const betragNum = rng.int(lo, hi);

    const daysAgo = rng.int(0, 89);
    const d = new Date(today);
    d.setDate(d.getDate() - daysAgo);
    const datum = `${pad2(d.getDate())}.${pad2(d.getMonth()+1)}.${String(d.getFullYear()).slice(2)}`;

    // Generate positionen (1-3 items summing to betragNum)
    const numPos = rng.int(1, 3);
    const procs = PROCS[typ] || PROCS["Kassenabrechnung"];
    const positionen = [];
    let remaining = betragNum;
    for (let j = 0; j < numPos; j++) {
      const bez = rng.pick(procs);
      let bet;
      if (j === numPos - 1) {
        bet = remaining;
      } else {
        bet = rng.int(Math.floor(remaining*0.2), Math.floor(remaining*0.7));
        remaining -= bet;
      }
      positionen.push({ bez, bet:`€${bet.toFixed(2)}` });
    }

    const nr = `2025-${String(i+1).padStart(4,"0")}`;
    invoices.push({
      nr,
      patient: `${p.nachname}, ${p.vorname}`,
      datum,
      kv: p.kv,
      betrag: `€${betragNum.toFixed(2)}`,
      betragNum,
      typ,
      status,
      notiz: "",
      positionen,
    });
  }

  return invoices;
}

function generateReviews() {
  const rng = seededRng(2026 + 4);

  const SRCS_DIST = [
    ...Array(55).fill("google"),
    ...Array(40).fill("jameda"),
    ...Array(25).fill("intern"),
  ];

  const NAMES_GOOGLE = ["Maria M.","Klaus W.","Stefan K.","Andrea B.","Thomas H.","Petra S.","Michael R.","Sabine L.","Hans G.","Monika F.","Robert Z.","Christine D.","Wolfgang N.","Elisabeth T.","Markus E."];
  const NAMES_JAMEDA = ["A. Fischer","K. Weber","P. Braun","H. Schmidt","E. Richter","L. Bauer","I. Wolf","B. Müller","U. Schäfer","F. Wagner","G. König","C. Meyer","D. Koch","V. Klein","N. Schulz"];
  const NAMES_INTERN = ["Patient 1","Patient 2","Patient 3","Patient 4","Patient 5","Patient 6","Patient 7","Patient 8","Patient 9","Patient 10"];

  const TEXTS_5 = [
    "Sehr freundliches Team, der Online-Termin hat super geklappt. Ich wurde sofort behandelt!",
    "Dr. Hoffmann nimmt sich immer viel Zeit. Sehr empfehlenswert!",
    "Das KI-Telefon hat meinen Termin in 2 Minuten vergeben. Zukunft der Arztpraxis!",
    "Tolle Praxis, sehr modernes System. Die App zur Terminbuchung ist sehr praktisch!",
    "Beste Zahnarztpraxis in der Region. Sehr professionell und einfühlsam.",
    "Alle Mitarbeiter sind sehr nett und professionell. Gerne komme ich wieder!",
    "Kurze Wartezeiten, freundliches Personal und kompetente Behandlung. Top!",
    "Sehr moderne Ausstattung und ein tolles Team. Ich fühle mich hier gut aufgehoben.",
    "Endlich eine Praxis mit digitalem Terminbuchungssystem. Einfach und unkompliziert.",
    "Hervorragende Behandlungsqualität. Das Team ist freundlich und professionell.",
  ];
  const TEXTS_4 = [
    "Kompetente Behandlung. Die Wartezeit war etwas lang, aber das Team war sehr freundlich.",
    "Gute Praxis, kurze Wartezeiten. Das Recall-System ist sehr praktisch.",
    "Professionelle Behandlung, nettes Team. Manchmal schwer telefonisch erreichbar.",
    "Generell bin ich sehr zufrieden. Kleine Verbesserungen bei der Terminvergabe wären wünschenswert.",
    "Gute Erfahrungen gemacht. Die Online-Terminbuchung ist sehr praktisch.",
    "Freundliches Team und gute Behandlung. Manchmal etwas lange Wartezeiten.",
    "Sehr gute Praxis. Die digitalen Möglichkeiten sind ein großer Vorteil.",
    "Kompetente Ärzte und nettes Personal. Wartezeiten könnten kürzer sein.",
  ];
  const TEXTS_3 = [
    "Behandlung war okay, aber die Kommunikation könnte besser sein.",
    "Mittelmäßige Erfahrung. Manchmal schwer erreichbar.",
    "Durchwachsen. Behandlung gut, aber Organisation lässt zu wünschen übrig.",
    "War zufrieden mit der Behandlung, aber Wartezeiten sind oft lang.",
    "Solide Praxis, aber noch Verbesserungsbedarf bei der Terminorganisation.",
    "Okay, nichts Besonderes. Erwartet hatte ich mehr.",
    "Die Behandlung war korrekt, aber der Service könnte besser sein.",
  ];
  const TEXTS_2 = [
    "Lange Wartezeiten, schwer erreichbar per Telefon.",
    "Nicht sehr zufrieden mit dem Service. Verbesserungen nötig.",
    "Wartezeiten sind inakzeptabel, trotz Terminvereinbarung.",
    "Kommunikation mit dem Personal war schwierig.",
    "Die Behandlung hat länger gedauert als erwartet. Enttäuschend.",
  ];
  const TEXTS_1 = [
    "Sehr unfreundliches Personal. Werde nicht wiederkommen.",
    "Katastrophale Erfahrung. Keine Empfehlung von mir.",
    "Viel zu lange Wartezeiten und schlechte Behandlung.",
    "Absolute Enttäuschung. Nie wieder.",
  ];

  const TEXT_BY_STARS = { 5: TEXTS_5, 4: TEXTS_4, 3: TEXTS_3, 2: TEXTS_2, 1: TEXTS_1 };

  const REPLIES = [
    "Vielen Dank für Ihr tolles Feedback!",
    "Danke für das schöne Feedback!",
    "Herzlichen Dank — wir freuen uns auf Ihren nächsten Besuch!",
    "Vielen Dank für Ihre Bewertung, das motiviert unser Team!",
    "Danke für Ihr Vertrauen — wir freuen uns über Ihr Lob!",
  ];

  const TIMES = ["heute, 08:31","heute, 09:14","heute, 10:22","gestern, 16:30","gestern, 14:12","gestern, 11:05","Mo., 14:30","Mo., 10:15","Di., 09:15","Di., 16:44","Mi., 11:30","Mi., 08:45","Do., 13:20","Do., 15:00","Fr., 09:30"];

  const STAR_DIST = [
    ...Array(52).fill(5),
    ...Array(24).fill(4),
    ...Array(12).fill(3),
    ...Array(8).fill(2),
    ...Array(4).fill(1),
  ];

  const reviews = [];
  for (let i = 0; i < 120; i++) {
    const src = SRCS_DIST[i % SRCS_DIST.length];
    const names = src==="google" ? NAMES_GOOGLE : src==="jameda" ? NAMES_JAMEDA : NAMES_INTERN;
    const name = rng.pick(names);
    const stars = STAR_DIST[rng.int(0, STAR_DIST.length-1)];
    const text = rng.pick(TEXT_BY_STARS[stars]);
    const date = rng.pick(TIMES);
    const hasReply = rng.next() < 0.25;
    const antwort = hasReply ? rng.pick(REPLIES) : "";
    reviews.push({ id: i+1, src, name, date, stars, text, antwort });
  }

  return reviews;
}

function generateApts(patients) {
  const rng = seededRng(2026 + 7);
  const BEHANDLER_IDS = ["dh","ds","lbe","tf","mr"];
  const TYPES = ["kontrolle","fuellung","endo","prothetik","prophylaxe","schmerz"];
  const ANLIEGEN = {
    kontrolle: ["Kontrolluntersuchung","Routinekontrolle","Jahres-Check"],
    fuellung:  ["Füllung 16","Füllung 26","Füllung 36","Füllung 46","Komposit"],
    endo:      ["Wurzelbehandlung 36","Wurzelbehandlung 46","WB 16"],
    prothetik: ["Krone einsetzen","Implantat-Kontrolle","Brücke anpassen"],
    prophylaxe:["PZR + Fluorid","PZR","Recall","UPT III","Paro-Kontrolle"],
    schmerz:   ["Akute Zahnschmerzen","Notfallbehandlung","Schmerz 36"],
  };
  const TIMES = ["07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"];
  const DURS = [30,45,60,90];
  const SRCS = ["Online","KI-Tel.","Telefonisch"];
  const STATUSES = ["gebucht","gebucht","gebucht","checkin","wartend","abgesagt"];
  const ROOMS = ["Zimmer 1","Zimmer 2","Behandlung A","Behandlung B",""];

  const today = new Date(2026,5,9); // 2026-06-09
  const apts = [];
  let id = 100;

  for (let dayOffset = -60; dayOffset <= 30; dayOffset++) {
    const d = new Date(today);
    d.setDate(d.getDate() + dayOffset);
    if (d.getDay() === 0 || d.getDay() === 6) continue; // Skip weekends

    const dateStr = d.toISOString().slice(0,10);
    const numApts = rng.int(6, 14);

    for (let j = 0; j < numApts; j++) {
      const pat = patients[rng.int(0, Math.min(199, patients.length-1))];
      const beh = BEHANDLER_IDS[rng.int(0, BEHANDLER_IDS.length-1)];
      const typ = TYPES[rng.int(0, TYPES.length-1)];
      const anl = rng.pick(ANLIEGEN[typ]);
      const time = TIMES[rng.int(0, TIMES.length-1)];
      const dur = DURS[rng.int(0, DURS.length-1)];
      const status = dayOffset < 0
        ? (rng.next() < 0.08 ? "abgesagt" : rng.next() < 0.05 ? "noshow" : "gebucht")
        : STATUSES[rng.int(0, STATUSES.length-1)];
      const src = rng.pick(SRCS);
      const room = rng.pick(ROOMS);
      apts.push({
        id: id++,
        date: dateStr,
        time,
        dur,
        patient: `${pat.vorname} ${pat.nachname}`,
        dob: pat.dob,
        allergy: pat.allergy !== "—" ? pat.allergy : "",
        behandler: beh,
        type: typ,
        anliegen: anl,
        status,
        src,
        kv: pat.kv,
        notes: "",
        room,
        waitSince: null,
      });
    }
  }
  return apts;
}

function generateRevenue() {
  const rng = seededRng(2026 + 99);
  const today = new Date(2026, 5, 9);
  const result = {};
  for (let i = 11; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(1);
    d.setMonth(d.getMonth() - i);
    const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
    const partial = i === 0 ? (9/30) : 1;
    const base = 70000 + rng.int(0, 25000);
    const gesamt = Math.round(base * partial);
    const kasse   = Math.round(gesamt * (0.50 + rng.next() * 0.10));
    const privat  = Math.round(gesamt * (0.22 + rng.next() * 0.06));
    const igel    = Math.max(0, gesamt - kasse - privat);
    const einnahmen = Math.round(gesamt * (0.65 + rng.next() * 0.15));
    const offen   = Math.max(0, gesamt - einnahmen);
    const kosten  = Math.round(gesamt * (0.30 + rng.next() * 0.08));
    result[key] = {
      gesamt, einnahmen, offen, kasse, privat, igel, kosten,
      behandler: {
        "Dr. Hoffmann":  Math.round(gesamt * 0.28),
        "Dr. Schulz":    Math.round(gesamt * 0.20),
        "Dr. Bergmann":  Math.round(gesamt * 0.25),
        "Dr. Fischer":   Math.round(gesamt * 0.15),
        "Maja Roth":     Math.round(gesamt * 0.12),
      }
    };
  }
  return result;
}

export function loadDemoData(force = false) {
  // Pilotmodus: nie automatisch neu seeden — nur explizit über den Button
  if (!force && localStorage.getItem('dida_clean') === '1') return;
  if (!force && localStorage.getItem('dida_demo_loaded') === 'v2') return;
  if (force) { try { localStorage.removeItem('dida_clean'); } catch {} }
  const patients = generatePatients();
  const apts = generateApts(patients);
  const data = {
    dida_team:     generateTeam(),
    dida_patients: patients,
    dida_reqs:     generateReqs(patients),
    dida_invoices: generateInvoices(patients),
    dida_reviews:  generateReviews(),
    dida_apts:     apts,
    dida_revenue:  generateRevenue(),
  };
  Object.entries(data).forEach(([k,v]) => {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch(e) { console.warn('demoData:', k, e); }
  });
  localStorage.setItem('dida_demo_loaded', 'v2');
}
